import { pickElement as $ } from "../../utils/pickelements";

import { ConditionArea } from "./conditionarea/conditionarea";
import { DownloadArea } from "./downloadarea/downloadarea";

(async () => {
    try {
        const conditionArea = new ConditionArea(
            $("#jemOriginTimeFrom"), $("#jemOriginTimeTo"),
            $("#mjmaFrom"), $("#mjmaTo"),
            $("#hypoDistFrom"), $("#hypoDistTo"),
            $("#useAcc"));

        const downloadArea = new DownloadArea($("#download_button"));

        conditionArea.on("change", (params) => {
            downloadArea.setParams(params);
        });

        await Promise.all([
            conditionArea.init(),
            downloadArea.init()]);
    } catch (e) {
        console.error(e);
        alert((Error.isError(e)) ? e.message : e);
    }
})();
